
import * as Models from "../ts/rlAdmin.models";
import * as Utils from "../ts/rlAdmin.utils";
import * as Consts from "../ts/rlAdmin.consts";
import { WorkflowService } from "../services/workflow-service";
import { DocGenService } from "../services/doc-gen-service";
import { NotifyService } from "../services/notify-service";
import { DocumentEntityService } from "../services/document-entity-service";
import { WorkflowConfigService } from "../services/workflow-config-service";
import { EntityService } from "../services/entity-service";
import { EventService } from "../services/event-service";
import { ContactService } from "../services/contact-service";
import { SearchService } from "../services/search-service";

export function RLEntityWorkflowNav() {
    var directive: ng.IDirective = {
        template: require("/assets/app/templates/entity-workflow-nav.html"),
        controller: RLEntityWorkflowNavController,
        controllerAs: "ewnVM",
        restrict: "AE",
        bindToController: true,
        scope: {
            entity: "=rlEntityWorkflowNav",
            callback: "&?",
            showWorkflowActions: "=?"
        }
    };
    return directive;
}

export interface IRLEntityWorkflowNavScope extends ng.IScope {
    entity: Models.IEntity;
    callback: () => ng.IPromise<any>;
    showWorkflowActions: boolean;
}

export class RLEntityWorkflowNavController {

    static $inject = ["$scope", "$rootScope", "$timeout", "$q", "workflowService", "notifyService", "workflowConfigService",
        "docGenService", "documentEntityService", "entityService", "eventService", "contactService", "searchService"];

    initialized: boolean;

    entity: Models.IEntity;
    callback: () => ng.IPromise<any>;
    showWorkflowActions: boolean;

    processID: number;
    statusID: number;
    templateID: number;
    charTypeID: number;
    recordID: number;
    hasAttachments: boolean;

    workflowActions: Models.IWFAction[];

    showBusyIndicator: boolean;
    isBusyProcessingModalAction: boolean;

    actionID: number;

    buttonDisabled: boolean;
    wfModel: Models.IWFAction[];

    draftDoc: boolean;
    docGenTemplateID: number;
    allDocGenTemplates: Models.IDocTemplate[];
    allDocGenFormats: Models.IDocGenTemplate[];
    docGenFormat: Models.IDocGenTemplate;

    showEditNotification: boolean;
    notifications: Models.IWFNotificationWithAttachments[];
    documents: Models.IEntityDocumentsCollection;
    uploadedDocuments: { [key: string]: string };
    selectedNotification: Models.IWFNotificationWithAttachments;
    editNotificationView: number;

    documentPreviewModalOpen: boolean;
    documentModalTitle: string;
    documentViewSrc: string;
    documentFileName: string;
    documentTemplateGroupId: number;

    showJobProgressStatus: boolean;
    jobId: string;
    jobTitle: string;
    progressStatus: string;

    entityContacts: Models.IKeyValuePair<string, string>[] = [];

    //Send for Signature
    eSignature: boolean;
    eSignatureChildCharType: number = Consts.CharTypeIDs.document;
    eSignatureAllowMultiple: boolean = false;
    eSignatureShowColumns: boolean = true;
    eSignatureCanCreate: boolean = false;
    eSignatureShowAdvance: boolean = false;
    eSignatureSelectedDocuments: Array<Models.IEntitySearchDoc>;
    eSignatureSelectedContacts: string[] = [];
    eSigContactsAdHoc: string;
    eSignatureIsBusyProcessingModalAction: boolean = false;

    eSignatureDocuments: Models.IEntitySearchDoc[] = [];
    eSignatureCustomColumns: Models.ICustomUserColumns;
    eSignatureVisibility: number = 1;
    eSignatureAllChecked: boolean;
    eSignaturePage: number = 1;
    eSignaturePageCount: number = 1;
    eSignatureRowCount: number = 10;
    eSignatureNumFound: number = 0;
    eSignatureSortField: string;
    eSignatureSortDir: number;
    eSignatureDocumentSelectionRequired: boolean = true;
    //
    documentDownloadUrls: { [key: number]: string };


    get shouldShowWorkflowActions() {
        return this.showWorkflowActions && this.workflowActions.length > 0;
    }

    constructor(private $scope: IRLEntityWorkflowNavScope, private $rootScope: ng.IRootScopeService, private $timeout: ng.ITimeoutService, private $q: ng.IQService,
        private workflowService: WorkflowService, private notifyService: NotifyService, private workflowConfigService: WorkflowConfigService,
        private docGenService: DocGenService, private documentEntityService: DocumentEntityService, private entityService: EntityService, private eventService: EventService,
        private contactService: ContactService, private searchService: SearchService) {

        this.initialized = false;

        this.processID = -1;
        this.statusID = -1;
        this.templateID = -1;
        this.charTypeID = -1;
        this.recordID = -1;

        this.workflowActions = [];

        this.showBusyIndicator = false;
        this.isBusyProcessingModalAction = false;

        this.actionID = -1;
        this.buttonDisabled = false;
        this.draftDoc = false;
        this.docGenTemplateID = null;
        this.allDocGenTemplates = [];
        this.allDocGenFormats = [];
        this.docGenFormat = null;

        this.showEditNotification = false;
        this.notifications = [];
        this.selectedNotification = null;
        this.editNotificationView = 0;
        this.initialized = false;
        this.documents = null;
        this.uploadedDocuments = {};
        this.documentPreviewModalOpen = false;
        this.documentDownloadUrls = {};

        this.hasAttachments = false;

        this.wfModel = [];

        $scope.$watchCollection(() => [this.showEditNotification, this.draftDoc], (newValue: any[], oldValue: any[]) => {
            if (!this.showEditNotification && !this.draftDoc) {
                this.showBusyIndicator = false;
            }
        });

        $scope.$watch(() => this.entity, (newValue: Models.IEntity, oldValue: Models.IEntity) => {
            if ((newValue !== oldValue || !this.initialized) && newValue != null) {
                this.statusID = newValue.statusID;
                this.templateID = newValue.templateID;
                this.charTypeID = newValue.charTypeID;
                this.recordID = newValue.recordID;
                this.initialized = true;
            }
        }, true);

        $scope.$watch(() => [this.statusID, this.templateID, this.charTypeID, this.recordID],
            (newValue: any[], oldValue: any[]) => {
                if (_.all<any>(newValue, (val) => !_.isNaN(_.parseInt(val)))) {
                    if (this.statusID > 0) {
                        workflowService.getAvailableWorkflowActions(this.charTypeID, this.templateID, this.statusID)
                            .then((result) => {
                                this.workflowActions = result;
                                if (this.workflowActions.length > 0) {
                                    this.processID = this.workflowActions[0].processID;
                                }
                            });
                    }
                }
            }, true);

        $scope.$watch(() => this.progressStatus, (newValue, oldValue) => {
            if (newValue != oldValue && (newValue == "Done" || newValue == "Failed")) {
                this.showJobProgressStatus = false;
                if (newValue == "Done") {
                    this.notifyService.notifySuccess("Workflow Action Successful.");
                }
                else {
                    this.notifyService.notifyError("Workflow Action Failed.");
                }
                entityService.getEntity(this.entity.id)
                    .then((result) => {
                        this.statusID = result.record.statusID;
                        this.$rootScope.$broadcast(Consts.Events.UpdateStatusHistory, this.entity.id);
                        if (this.callback != null) {
                            return this.callback()
                                .then(() => {
                                    return this.eventService.call(Consts.Events.WorkflowExecuted + this.entity.id);
                                });
                        }
                        else {
                            return this.eventService.call(Consts.Events.WorkflowExecuted + this.entity.id);
                        }
                    });
            }
        });
    }

    Execute(workflowAction: Models.IWFAction) {  //when selecting action from dropdown

        this.actionID = workflowAction.actionID;

        this.showBusyIndicator = true;
        this.showJobProgressStatus = false;

        if (this.ActionHasDocumentIndicator(this.actionID, Consts.DocumentIndicators.DocumentGeneration)) { //triggers modal with doc gen options
            if (this.allDocGenTemplates.length == 0) {
                this.notifyService.startProgress();
                this.LoadDocGenFormats();
                this.LoadTemplateTypes(this.charTypeID, this.templateID)
                    .then(() => {
                        this.draftDoc = true;
                    })
                    .finally(() => {
                        this.notifyService.endProgress();
                    });
            }
            else {
                this.draftDoc = true;
            }
        }
        else if (this.ActionHasDocumentIndicator(this.actionID, Consts.DocumentIndicators.SendForSignature)) {
            //Get the documents on the entity
            this.notifyService.startProgress();

            var docSearchReq: Models.IAdvancedSearchModel = {
                charTypeID: Consts.CharTypeIDs.document,
                keywords: "",
                searchGroups: [],
                rowCount: this.eSignatureRowCount,
                page: this.eSignaturePage,
                relatedEntityID: this.entity.id,
                sortDir: this.eSignatureSortDir,
                sortField: this.eSignatureSortField
            }

            this.searchService.advancedSearch(docSearchReq)
                .then((results) => {
                    this.eSignatureDocuments = results.documents;
                    this.eSignatureNumFound = results.numFound;
                    this.eSignaturePageCount = Math.ceil(results.numFound / this.eSignatureRowCount);

                    //Get contacts on the entity
                    this.contactService.getContactsForEntity(this.entity.id)
                        .then((results) => {
                            this.entityContacts = [];

                            results.forEach(cp => {
                                cp.contacts.forEach(c => {
                                    //Check if the template has email
                                    var email = "";
                                    if (c.charDataCollection.charDatas["email"]) {
                                        email = c.charDataCollection.charDatas["email"].length > 0 ? c.charDataCollection.charDatas["email"][0].value : "";
                                    }

                                    var name = c.charDataCollection.charDatas["entity_title"].length > 0 ? c.charDataCollection.charDatas["entity_title"][0].value : "";

                                    var contact: Models.IKeyValuePair<string, string> = { key: email, value: name };

                                    //Make sure we don't already have the contact in the list
                                    var index = _.findIndex(this.entityContacts, function (o) { return o.key == email; });

                                    if (index < 0) {
                                        this.entityContacts.push(contact);
                                    }

                                });
                            });

                            this.eSignature = true;
                        });
                })
                .finally(() => {
                    this.notifyService.endProgress();
                });
        }
        else {
            this.notifyService.startProgress();
            this.GetPreviewNotifications(this.processID, this.actionID)
                .then((result) => {
                    this.notifications = result.notifications;
                    if (!_.isEmpty(this.notifications)) {
                        this.LoadAttachments();
                    }
                    else {
                        var batchID: string = '';
                        return this.workflowService.createBatchID()
                            .then((batchIDResult) => {
                                batchID = batchIDResult.batchID;
                                return this.workflowConfigService.getWorkflowActionExtensions(this.processID, this.actionID)
                                    .then((results) => {
                                        if (results.extensions.length > 0) {

                                            if (_.any(results.paths, (wfextpath) => wfextpath.pathTypeID == Consts.WorkflowExtPathType.ExecuteService)) {
                                                return this.ExecuteWorkflowAsJob(batchID);
                                            }
                                            else {
                                                return this.ExecuteWorkflow(batchID);
                                            }
                                        }
                                        else {
                                            return this.ExecuteWorkflow(batchID)
                                                .then(() => {
                                                    this.notifyService.notifySuccess("Workflow action successful!");
                                                });
                                        }
                                    });
                            }).finally(() => {
                                this.showBusyIndicator = false;
                            });
                    }
                }).finally(() => {
                    this.notifyService.endProgress();
                });
        }
    }

    SendForSignature(form: ng.IFormController) {
        if (form.$valid) {
            var batchID: string = '';
            return this.workflowService.createBatchID()
                .then((batchIDResult) => {
                    batchID = batchIDResult.batchID;
                    return this.ExecuteWorkflow(batchID)
                        .then(() => {
                            this.eSignatureIsBusyProcessingModalAction = true;
                            this.notifyService.startProgress();

                            var selectedDocumentEntityID = _.first(this.eSignatureSelectedDocuments).entityID;

                            //Append any ad hoc signatures to the list
                            if (this.eSigContactsAdHoc != null) {
                                var adHoc = this.eSigContactsAdHoc.replace(/\s+/g, '').split(",");
                                this.eSignatureSelectedContacts = this.eSignatureSelectedContacts.concat(adHoc);
                            }

                            this.documentEntityService.sendForSignature(this.entity.id, selectedDocumentEntityID, this.eSignatureSelectedContacts)
                                .then(() => {
                                    this.notifyService.notifySuccess("Send for signature successful!");
                                },
                                    () => {
                                        this.notifyService.notifyError("There was an error sending the document for signature."); // todo - pull back specific error message from e-signature integration
                                    });

                        }).finally(() => {
                            //Clear out the stored contacts
                            this.eSignatureSelectedContacts = [];
                            this.eSigContactsAdHoc = "";

                            this.eSignature = false;
                            this.showBusyIndicator = false;
                            this.isBusyProcessingModalAction = false;
                            this.notifyService.endProgress();
                        });
                });
        }
    }

    CancelESignature() {
        this.notifyService.broadcastDone();
        this.showBusyIndicator = false;
        this.eSignature = false;
        this.eSignatureSelectedDocuments = [];
        this.eSignatureSelectedContacts = [];
    }

    SetEditNotificationView(val: number) {
        this.editNotificationView = val;
    }

    LoadDocGenFormats() {
        //currently only two
        this.allDocGenFormats = [];
        this.allDocGenFormats.push(<Models.IDocGenTemplate>{ id: 1, name: Consts.DocGenFormats.PDF });
        this.allDocGenFormats.push(<Models.IDocGenTemplate>{ id: 2, name: Consts.DocGenFormats.DOCX });
        this.docGenFormat = _.find(this.allDocGenFormats, dgf => dgf.id = 1);
    }

    LoadTemplateTypes(charTypeID: number, charTemplateID: number): ng.IPromise<any> {
        this.notifyService.startProgress();
        var request = <Models.IDocTemplateByCharTemplateRequest>{};
        request.charTemplateID = charTemplateID;
        request.charTypeID = charTypeID;
        return this.workflowService.getDocTemplatesByCharTemplate(request)
            .then((results) => {
                this.allDocGenTemplates = results;
                if (_.any(this.allDocGenTemplates)) {
                    this.docGenTemplateID = this.allDocGenTemplates[0].documentTemplateID;
                }
            })
            .finally(() => {
                this.notifyService.endProgress();
            });
    }

    CancelNotificationEdit() {
        this.notifyService.broadcastDone();
        this.showEditNotification = false;
    }

    Cancel() {
        this.notifyService.broadcastDone();
        this.draftDoc = false;
    }

    GenerateDoc(form: ng.IFormController) {
        if (form.$valid) {

            this.isBusyProcessingModalAction = true;
            this.notifyService.startProgress();

            var req = <Models.IDocGenRequest>{};
            req.actionID = this.actionID;
            req.characteristicTypeID = this.charTypeID;
            req.documentTemplateID = this.docGenTemplateID;
            req.recordID = this.recordID;
            req.formatType = this.docGenFormat.id;
            req.processID = _.find(this.workflowActions, (a) => { return a.actionID == this.actionID; }).processID;
            req.requestRevisionID = 0;
            req.templateFileName = _.find(this.allDocGenTemplates, (t) => { return t.documentTemplateID == this.docGenTemplateID; }).fileName;

            this.docGenService.createDoc(req)
                .then((result) => {
                    if (!result.success) {
                        this.notifyService.notifyError("There was an error trying to generate the document.");
                        this.isBusyProcessingModalAction = false;
                        this.notifyService.endProgress();
                    }
                    else {
                        var fileName = result.fileName;
                        this.eventService.call(Consts.Events.DocumentGenerated);
                        this.workflowService.createBatchID()
                            .then((batchIDResult) => {
                                this.RunPreProcess(this.charTypeID, this.processID, this.actionID, this.recordID, this.statusID)
                                    .then(() => {
                                        this.ExecuteWorkflow(batchIDResult.batchID)
                                            .then(() => {
                                                this.draftDoc = false;
                                                var entityID = Utils.IdBuilder.buildEntityID(0, this.charTypeID, this.recordID);
                                                this.entityService.getEntityDocumentDownloadUrls(entityID)
                                                    .then((result) => {
                                                        var docDownloadUrlKeys = _.keys(result);
                                                        _.forEach(docDownloadUrlKeys, (key) => {
                                                            var numberKey = _.parseInt(key);
                                                            if (numberKey > 0) {
                                                                var fullFileName = result[key];
                                                                if (fullFileName.indexOf(fileName) > -1) {
                                                                    this.documentPreviewModalOpen = true;
                                                                    this.documentModalTitle = fileName;
                                                                    this.documentFileName = fileName;
                                                                    this.documentViewSrc = result[key];
                                                                    this.documentTemplateGroupId = Consts.TemplateGroupIDs.RightslineDocTemplateGroup;
                                                                }
                                                            }
                                                        });
                                                    });
                                                this.notifyService.notifySuccess("Workflow action successful!");
                                            },
                                                () => {
                                                    this.notifyService.notifyError("There was an error executing your workflow action.");
                                                })
                                            .finally(() => {
                                                this.isBusyProcessingModalAction = false;
                                                this.notifyService.endProgress();
                                            });
                                    });
                            });
                    }
                });
        }
        else {
            //console.log("form validation error");
        }
    }

    ActionHasDocumentIndicator(actionID: number, documentIndicator: number) {
        var a = _.find(this.workflowActions, (_a) => { return _a.actionID == actionID; });
        return a.docGenIndicator == documentIndicator;
    }

    SetAttachments(notification: Models.IWFNotificationWithAttachments): ng.IPromise<any> {
        var entityID = Utils.IdBuilder.buildEntityID(notification.divisionID, this.charTypeID, this.recordID);
        return this.entityService.getEntityDocuments(entityID)
            .then((results: Models.IEntityDocumentsCollection) => {
                this.documents = results;
            });
    }

    SetDocumentDownloadUrls(notification: Models.IWFNotificationWithAttachments): ng.IPromise<any> {
        var entityID = Utils.IdBuilder.buildEntityID(notification.divisionID, this.charTypeID, this.recordID);
        this.documentDownloadUrls = {};
        return this.entityService.getEntityDocumentDownloadUrls(entityID)
            .then((result) => {
                this.documentDownloadUrls = result;
            });
    }

    SetDocumentsHierarchyAsFlatList(notification: Models.IWFNotificationWithAttachments): ng.IPromise<any> {
        var entityID = Utils.IdBuilder.buildEntityID(notification.divisionID, this.charTypeID, this.recordID);
        this.uploadedDocuments = {};
        return this.entityService.getEntityDocumentsHierarchyAsFlatList(entityID)
            .then((result) => {
                var removeStr = "S3/div_" + notification.divisionID + "/documents/" + entityID + "/";
                var keys = _.keys(result);
                _.forEach(keys, (key) => {
                    var numberKey = _.parseInt(key);
                    if (numberKey > 0) {
                        var fullFileName = result[key];
                        var fileName = fullFileName.replace(removeStr, '');
                        this.uploadedDocuments[key] = fileName;
                    }
                });
            });
    }

    SetNotificationAttachments(notification: Models.IWFNotificationWithAttachments): ng.IPromise<any> {
        return this.workflowService.getNotificationAttachments(this.charTypeID, this.recordID, 0, notification.id, 0)
            .then((results) => {
                var recentAttachments: Models.ISelectedNotifications[] = [];
                if (results.length > 0) {
                    _.forEach(results, attachment => {
                        var index = attachment.lastIndexOf('\\');
                        attachment = attachment.substring(index + 1);
                        index = attachment.lastIndexOf('/');
                        attachment = attachment.substring(index + 1);
                        recentAttachments.push({ selected: true, attachment: attachment });
                        this.hasAttachments = true;
                    });
                    notification.attachments = recentAttachments;
                }
            });
    }

    GetNotificationsForAction(actionID: number): ng.IPromise<any> {
        var retVal = false;
        var a = _.find(this.workflowActions, (_a) => { return _a.actionID == actionID; });
        return this.workflowConfigService.getEditAction(a.processID, a.actionID, this.charTypeID)
            .then((result) => {
                var action = result;
                return action.selectedRoleNotifications;
            });
    }

    SendNotifications() { //from edit/preview modal           
        this.isBusyProcessingModalAction = true;
        this.notifyService.startProgress();

        var action = _.find(this.workflowActions, (_a) => { return _a.actionID == this.actionID; });

        var request: Models.IWFSendNotificationsRequest = {
            charTypeID: this.entity.charTypeID,
            recordID: this.entity.recordID,
            processID: this.processID,
            actionID: action.actionID,
            notifications: this.notifications,
            downloadURLs: {}
        };

        for (var doc in this.documentDownloadUrls) {
            request.downloadURLs[doc] = this.documentDownloadUrls[doc];
        }

        this.workflowService.sendNotifications(request)
            .then(() => {
                this.showEditNotification = false;
                this.isBusyProcessingModalAction = false;
                this.notifyService.endProgress();
                this.notifyService.notifySuccess("Workflow action successful!");
                this.$rootScope.$broadcast(Consts.Events.UpdateStatusHistory, this.entity.id);
                this.eventService.call(Consts.Events.WorkflowExecuted + this.entity.id);
            });
    }

    GetPreviewNotifications(processID: number, actionID: number): ng.IPromise<any> {
        return this.workflowConfigService.getPreviewNotifications(processID, actionID);
    }

    LoadAttachments() {
        var promises = [];
        _.each(this.notifications, (n) => {
            promises.push(this.SetAttachments(n));
            promises.push(this.SetDocumentDownloadUrls(n));
            promises.push(this.SetDocumentsHierarchyAsFlatList(n));
            promises.push(this.SetNotificationAttachments(n));
        });

        this.$q.all(promises)
            .then(() => {
                this.selectedNotification = this.notifications[0];
                this.SetEditNotificationView(0);
                this.showEditNotification = true;
            });
    }

    /*individual steps*/

    AddNotificationsToQueue(charTypeID: number, recordID: number, actionID: number, batchID: string, processID: number): ng.IPromise<any> {
        return this.workflowService.addNotificationsToQueue(charTypeID, recordID, actionID, batchID, processID);
    }

    RunPreProcess(charTypeID: number, processID: number, actionID: number, recordID: number, statusID: number): ng.IPromise<any> {
        return this.workflowService.runPreProcess(charTypeID, processID, actionID, recordID, statusID);
    }

    RunPostProcess(charTypeID: number, processID: number, actionID: number, recordID: number, statusID: number): ng.IPromise<any> {
        return this.workflowService.runPostProcess(charTypeID, processID, actionID, recordID, statusID);
    }

    SendNotificationsFromQueue(charTypeID: number, recordID: number, batchID: string): ng.IPromise<any> {
        return this.workflowService.sendNotificationsFromQueue(charTypeID, recordID, batchID);
    }

    WorkflowUpdateEntityStatus(charTypeID: number, processID: number, actionID: number, recID: number, statusID: number): ng.IPromise<any> {
        return this.workflowService.workflowUpdateEntityStatus(charTypeID, processID, actionID, recID, statusID);
    }

    /*individual steps*/

    ExecuteWorkflowAsJob(batchID: string): ng.IPromise<any> {
        var recIDs: number[] = [];
        recIDs.push(this.recordID);
        return this.workflowService.executeWorkflowJob(this.charTypeID, recIDs, this.actionID, this.processID, batchID)
            .then((result) => {
                this.showJobProgressStatus = true;
                this.jobId = result.jobID;
                this.jobTitle = result.jobTitle;
            });
    }

    ExecuteWorkflow(batchID: string): ng.IPromise<any> {
        this.showJobProgressStatus = false;
        var recIDs: number[] = [];
        recIDs.push(this.recordID);
        return this.workflowService.executeWorkflow(this.charTypeID, recIDs, this.actionID, this.processID, batchID)
            .then((result) => {
                var newStatusID = result.newStatusID;
                if (newStatusID != this.statusID) {
                    this.statusID = newStatusID;
                }
                this.$rootScope.$broadcast(Consts.Events.UpdateStatusHistory, this.entity.id);
                if (this.callback != null) {
                    return this.callback()
                        .then(() => {
                            return this.eventService.call(Consts.Events.WorkflowExecuted + this.entity.id);
                        });
                }
                else {
                    return this.eventService.call(Consts.Events.WorkflowExecuted + this.entity.id);
                }
            });
    }

    CloseDocModal() {
        this.documentFileName = "";
        this.documentModalTitle = "";
        this.documentViewSrc = "";
        this.documentPreviewModalOpen = false;
    }
}